var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"purshase-product-list"},_vm._l((_vm.purshaseProducts),function(product,index){return _c('purshase-product-info',{key:'pp'+product.id,attrs:{"purshaseProduct":product,"index":index+1}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }